export default __webpack_public_path__ + "static/media/gallery_01.63ac136e.jpg";